import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./features/home/home').then(m => m.HomeComponent),
  },
  {
    path: 'lobby/:id',
    loadComponent: () => import('./features/lobby/lobby').then(m => m.LobbyComponent),
  },
  {
    path: 'game/:id',
    loadComponent: () => import('./features/game-room/game-room').then(m => m.GameRoomComponent),
  },
  {
    path: 'voting/:id',
    loadComponent: () => import('./features/voting/voting').then(m => m.VotingComponent),
  },
  { path: '**', redirectTo: '' },
];
